<!--
/**
 * OrangeHRM WhatsApp Meta configuration page
 */
 -->

<template>
  <div class="orangehrm-background-container">
    <div class="orangehrm-card-container">
      <oxd-text tag="h6" class="orangehrm-main-title">
        WhatsApp Configuration
      </oxd-text>
      <oxd-divider />

      <oxd-form :loading="isLoading" @submitValid="onSave">
        <oxd-form-row>
          <oxd-grid :cols="2" class="orangehrm-full-width-grid">
            <oxd-grid-item>
              <oxd-input-field
                v-model="form.phoneNumberId"
                label="Phone Number ID"
                required
              />
            </oxd-grid-item>
            <oxd-grid-item>
              <oxd-input-field v-model="form.wabaId" label="WABA ID" />
            </oxd-grid-item>
            <oxd-grid-item>
              <oxd-input-field
                v-model="form.accessToken"
                label="Access Token"
                required
              />
            </oxd-grid-item>
            <oxd-grid-item>
              <oxd-input-field v-model="form.appSecret" label="App Secret" />
            </oxd-grid-item>
            <oxd-grid-item>
              <oxd-input-field
                v-model="form.verifyToken"
                label="Webhook Verify Token"
                required
              />
            </oxd-grid-item>
            <oxd-grid-item>
              <oxd-input-field
                v-model="form.displayNumber"
                label="Business WhatsApp Number (shown to employees)"
                placeholder="+91 98XXXXXXXX"
              />
            </oxd-grid-item>
            <oxd-grid-item>
              <oxd-input-field
                v-model="form.otpTemplateName"
                label="OTP Template Name"
              />
            </oxd-grid-item>
            <oxd-grid-item>
              <oxd-input-field
                v-model="form.otpTemplateLang"
                label="OTP Template Language"
              />
            </oxd-grid-item>
            <oxd-grid-item>
              <oxd-input-field
                v-model="form.graphVersion"
                label="Graph API Version"
              />
            </oxd-grid-item>
            <oxd-grid-item>
              <oxd-input-field
                v-model="form.digestHour"
                label="Daily digest hour (IST, 0-23)"
                placeholder="10"
              />
            </oxd-grid-item>
            <oxd-grid-item>
              <oxd-input-field
                v-model="form.hrNotifyNumbers"
                label="Extra HR notify numbers (comma-separated E.164)"
                placeholder="+9198XXXXXXXX,+9197XXXXXXXX"
              />
            </oxd-grid-item>
            <oxd-grid-item>
              <oxd-input-field
                v-model="form.approvalTemplateName"
                label="Approval notify template (Meta template name)"
                placeholder="e.g. redim_approval_notify"
              />
            </oxd-grid-item>
            <oxd-grid-item>
              <oxd-input-field
                v-model="form.reminderTemplateName"
                label="Reminder template (Meta name — managers)"
                placeholder="redim_approval_reminder"
              />
            </oxd-grid-item>
            <oxd-grid-item>
              <oxd-input-field
                v-model="form.digestTemplateName"
                label="Digest template (Meta name — morning blast)"
                placeholder="redim_daily_digest"
              />
            </oxd-grid-item>
          </oxd-grid>
        </oxd-form-row>

        <oxd-divider />
        <oxd-text tag="p">
          Meta webhook callback URL:
        </oxd-text>
        <oxd-text tag="p">
          {{ webhookUrl }}
        </oxd-text>
        <oxd-text tag="p" style="margin-top: 0.75rem">
          Cron (every 1–5 min) for digests / approval reminders:
        </oxd-text>
        <oxd-text tag="p">
          {{ scheduleUrl }}
        </oxd-text>
        <oxd-divider />

        <oxd-form-actions>
          <submit-button />
        </oxd-form-actions>
      </oxd-form>
    </div>
  </div>
</template>

<script>
import {APIService} from '@/core/util/services/api.service';

export default {
  name: 'WhatsAppConfig',
  setup() {
    const http = new APIService(
      window.appGlobal.baseUrl,
      'api/v2/whatsapp/config',
    );
    return {http};
  },
  data() {
    return {
      isLoading: false,
      form: {
        phoneNumberId: '',
        wabaId: '',
        accessToken: '',
        appSecret: '',
        verifyToken: '',
        otpTemplateName: 'orangehrm_otp',
        otpTemplateLang: 'en',
        graphVersion: 'v19.0',
        displayNumber: '',
        digestHour: '10',
        hrNotifyNumbers: '',
        approvalTemplateName: '',
        reminderTemplateName: '',
        digestTemplateName: '',
      },
    };
  },
  computed: {
    webhookUrl() {
      const path = `${window.appGlobal.baseUrl}/whatsapp/webhook`;
      return `${window.location.origin}${path}`;
    },
    scheduleUrl() {
      const path = `${window.appGlobal.baseUrl}/whatsapp/schedule`;
      const token = this.form.verifyToken || 'YOUR_VERIFY_TOKEN';
      return `${window.location.origin}${path}?token=${encodeURIComponent(token)}`;
    },
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      this.isLoading = true;
      this.http
        .request({method: 'GET'})
        .then((response) => {
          const data = response.data?.data || {};
          this.form = {
            phoneNumberId: data.phoneNumberId || '',
            wabaId: data.wabaId || '',
            accessToken: data.accessToken || '',
            appSecret: data.appSecret || '',
            verifyToken: data.verifyToken || '',
            otpTemplateName: data.otpTemplateName || 'orangehrm_otp',
            otpTemplateLang: data.otpTemplateLang || 'en',
            graphVersion: data.graphVersion || 'v19.0',
            displayNumber: data.displayNumber || '',
            digestHour:
              data.digestHour !== undefined && data.digestHour !== null
                ? String(data.digestHour)
                : '10',
            hrNotifyNumbers: data.hrNotifyNumbers || '',
            approvalTemplateName: data.approvalTemplateName || '',
            reminderTemplateName: data.reminderTemplateName || '',
            digestTemplateName: data.digestTemplateName || '',
          };
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    onSave() {
      this.isLoading = true;
      this.http
        .request({
          method: 'PUT',
          data: this.form,
        })
        .then(() => {
          this.$toast.saveSuccess();
          this.load();
        })
        .catch(() => {
          this.$toast.error({
            title: 'Error',
            message: 'Failed to save WhatsApp configuration',
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
